<template lang="pug">
  div(class="greensky-results-container")
    SingleOffer(class="full-width mb-4")
    v-flex.xs12(class="mt-2 px-4 text-xs-left")
      p(class="title")
        b Plan Description: 
      p {{selectedOffer.promotion_details}}
    RecalculateOffer(@persistState="makeStatePersist")
    v-flex.xs12(class="my-2 px-5 text-xs-center") In order to activate your account and make a purchase, you must click 'ACCEPT OFFER'
    AppNextButton(v-if="!sending" :buttonFunction="acceptAndFinish") Accept Offer
    AppNextButton(v-else) Sending...
    StatusModal(:companyImage="greenskySvg" :secondaryButtonFunction="returnHome" :showModal="greenskyModal")
      div(slot="main-text") <h1>Thank you for accepting the offer!</h1>
      div(slot="secondary-text") <div class="text">To complete the last step, Applicant and Co-Applicant (if applicable) must <strong>activate</strong> their loan by responding to the text or email that has been sent to them. <br />If an email or text has not been received, they must call GreenSky® at <PhoneLink :phoneNumber="'866-936-0602'" :layout="'inline'"/> to activate their account.</div>
      span(v-if="this.easyLinkUser" slot="secondary-button-text") <p class="text">Close and Clear Data</p>
      span(v-else slot="secondary-button-text") <p class="text">Return Home</p>
    v-flex.xs12(
      class="px-3 pt-2 text-xs-left caption"
    )
      div(
        class="full-width"
        v-html="greenskyMainFooter"
      )
</template>

<script>
  import AppNextButton from 'Components/AppNextButton.vue'
  import PhoneLink from 'Components/PhoneLink.vue'
  import RecalculateOffer from 'Components/RecalculateOffer.vue'
  import SingleOffer from 'Components/SingleOffer.vue'
  import StatusModal from 'Components/StatusModal.vue'
  import { mapGetters, mapState, mapActions } from 'vuex'
  import { greenskyFooter } from 'Helpers/CreditApplicationFormHelper.js'

  export default {
    name: 'GreenskyResults',
    components: {
      AppNextButton,
      PhoneLink,
      RecalculateOffer,
      SingleOffer,
      StatusModal,
    },
    data () {
      return {
        greenskyModal: false,
        sending: false,
        greenskySvg: require('Assets/greensky_logo.svg'),
        recalculateField: false,
        recalculateAmount: '',
        persistState: false,
        minLoanError: false,
        maxLoanError: false,
        money: {
          prefix: '$',
          precision: 0,
          thousands: ',',
          decimal: '.'
        },
        greenskyMainFooter: '',
      }
    },
    computed: {
      ...mapGetters([
        'selectedOffer',
        //Using greenskyLink getter to set redirect url in view loan agreement
        'greenskyLink'
      ]),
      ...mapState({
        applicationId: state => state.loanApplication.applicationId,
        customerData: state => state.loanApplication.customerData,
        lender: state => state.loanApplication.lender,
        loanAmount: state => state.loanApplication.loanAmount,
        loanDocument: state => state.loanApplication.loanDocument,
        easyLinkUser: state => state.easyLink.active,
      })
    },
    methods: {
      ...mapActions([
        'acceptOffer',
        'sendEmailToCustomer',
        'recalculateOffers',
        'loanApplicationClear',
        'getGreenskyLegalContent',
      ]),
      acceptAndFinish () {
        this.sending = true
        this.acceptOffer().then(success => {
          this.sendEmailToCustomer()
          this.greenskyModal = true
        })
      },
      makeStatePersist () {
        this.persistState = true
      },
      returnHome () {
        if (this.easyLinkUser) {
          this.$router.push({
            path: '/credit-application/application-done'
          })
        } else {
          this.$router.push({
            path: '/home'
          })
        }
      }
    },
    async mounted() {
      if (this.lender.id === 'greensky'){
        this.greenskyMainFooter = await this.getGreenskyLegalContent(greenskyFooter)
      } else {
        this.greenskyMainFooter = greenskyFooter()
      }
    },
    destroyed () {
      if (!this.persistState) {
        this.loanApplicationClear()
      }
    }
  }
</script>

<style scoped lang="scss">
  .greensky-results-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .recalculate-container {
    width: 70%;
  }

  .recalculate-input {
    font-size: 1.8em;
  }

  .text {
    text-align: left;
    font-size: 1.3rem;
  }
</style>
